<template>
    <div>
        <page-title>应用订单</page-title>
        <page-body>
            <list-header>
                <div flex="dir:left box:last cross:center" style="height: 40px;">
                    <div>
                        <router-link to="/dashboard/app-order/edit"><el-button type="primary" size="small" round>购买应用</el-button></router-link>
                    </div>
                    <div>
                        <el-form @submit.native.prevent :inline="true">
                            <el-form-item style="margin-bottom: 0;">
                                <el-checkbox size="mini" border v-model="all">全局搜索</el-checkbox>
                            </el-form-item>
                            <el-form-item style="margin-bottom: 0; max-width: 150px">
                                <el-input v-model="keyword"
                                          @keyup.enter.native="search()"
                                          size="mini"
                                          placeholder="应用订单号/域名"
                                          suffix-icon="el-icon-search"/>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </list-header>
            <el-table v-loading="loading" :data="list" style="width: 100%">
                <el-table-column prop="app.display_name" label="应用"></el-table-column>
                <el-table-column prop="host" label="站点">
                    <template slot-scope="scope">
                        <div>名称: {{scope.row.host.name}}</div>
                        <div>域名: {{scope.row.host.domain}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="order_no" label="订单">
                    <template slot-scope="scope">
                        <div>订单号: {{scope.row.order_no}}</div>
                        <div>下单时间: {{scope.row.add_time}}</div>
                        <div>金额: <span style="text-decoration: line-through">{{scope.row.price}}</span></div>
                        <div>实际支付: <span>{{scope.row.pay_price}}</span></div>
                    </template>
                </el-table-column>
                <el-table-column prop="add_time" label="有效期">
                  <template slot-scope="scope">
                    <template v-if="scope.row.is_forever === 1">
                      <div style="color: #909399; font-size: 12px;">无限制</div>
                    </template>
                    <template v-else>
                      <el-tooltip class="item" content="开始时间" placement="left">
                        <div style="color: #909399; font-size: 12px;">{{scope.row.begin_time}}</div>
                      </el-tooltip>
                      <el-tooltip v-if="scope.row.update_time" class="item" content="更新时间" placement="left">
                        <div style="color: #909399; font-size: 12px;">{{scope.row.update_time}}</div>
                      </el-tooltip>
                      <el-tooltip class="item" content="到期时间" placement="left">
                        <div style="color: #909399; font-size: 12px;">{{scope.row.end_time}}</div>
                      </el-tooltip>
                    </template>
                  </template>
                </el-table-column>
                <el-table-column prop="is_pay" label="状态">
                    <template slot-scope="scope">
                        <span style="color: #909399" v-if="scope.row.is_pay === 0">未支付</span>
                        <span style="color: #67C23A" v-else-if="scope.row.is_pay === 1">已授权</span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    style="margin: 20px -5px;padding: 0"
                    background
                    layout="prev, pager, next"
                    :page-size="parseInt(pagination && pagination.pageSize ? pagination.pageSize : 10)"
                    @current-change="pageChange"
                    :total="parseInt(pagination && pagination.totalCount ? pagination.totalCount : 0)">
            </el-pagination>
        </page-body>
    </div>
</template>

<script>
import axios from '@/axios'

export default {
    components: {
        'UploadCertificate': () => import('@/components/UploadCertificate.vue')
    },
    data() {
        return {
            all: null,
            loading: true,
            list: null,
            pagination: null,
            keyword: '',
            app: null,
            disabled: true
        }
    },
    created() {
        this.loadData(0)
    },
    methods: {

        loadData(page) {
            this.getList(page).then(e => {
                this.list = e.list
                this.pagination = e.pagination
            })
        },
        getList(page) {
            return new Promise(resolve => {
                this.loading = true
                axios({
                    url: 'user/app-order/index',
                    params: {
                        page: page,
                        keyword: this.keyword,
                        all: this.all
                    }
                }).then(e => {
                    this.loading = false
                    if (e.data.code === 0) {
                        resolve(e.data.data)
                    }
                })
            })
        },
        search() {
            this.loadData(0)
        },
        pageChange(page) {
            this.loadData(page - 1)
        }
    }
}
</script>

<style scoped>

</style>
